module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }]
  }, [_c('div', {
    staticClass: "item-overlay show"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "loading md"
  }), _vm._v(" "), (_vm.status !== null) ? _c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.status))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52abe183","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/LoadOverlay.vue
// module id = 1666
// module chunks = 17